import type AgentApiCandidateMailsRecord from '@/types/serializers/AgentApiCandidateMailsRecord';

export type CandidateMailBoxFolder = 'sent' | 'scheduled' | 'archive';

export function mailFolderOf(mail: AgentApiCandidateMailsRecord): CandidateMailBoxFolder {
  switch (mail.status) {
    case 'scheduled':
      return 'scheduled';
    case 'canceled':
    case 'failed':
      return 'archive';
    default:
      return 'sent';
  }
}

export function mailCreatorName(mail: Pick<AgentApiCandidateMailsRecord, 'organization_user'>) {
  if (!mail.organization_user) return '削除されたユーザー';
  return mail.organization_user.name?.trim() || '未設定';
}

export function matchesKeyword(haystacks: Array<string | null | undefined>, keyword: string) {
  const terms = keyword.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (terms.length === 0) return true;
  const normalized = haystacks.map((value) => (value ?? '').toLowerCase());
  return terms.every((term) => normalized.some((value) => value.includes(term)));
}

export function matchesMailKeyword(mail: AgentApiCandidateMailsRecord, keyword: string) {
  return matchesKeyword(
    [mail.subject, mail.body, mail.organization_user?.name, ...mail.recipient_names],
    keyword
  );
}

export function toBodyPreview(body: string | null | undefined) {
  return (body ?? '').replace(/\s+/g, ' ').trim();
}
